import { render, staticRenderFns } from "./QnaHeader.vue?vue&type=template&id=58b0b6fc&scoped=true"
import script from "./QnaHeader.vue?vue&type=script&lang=js"
export * from "./QnaHeader.vue?vue&type=script&lang=js"
import style0 from "./QnaHeader.vue?vue&type=style&index=0&id=58b0b6fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b0b6fc",
  null
  
)

export default component.exports